import React from 'react'
import styled, { keyframes } from 'styled-components'

// ============================================
// HOVER ANIMATION COMPONENTS
// ============================================

// Animation: Gradient Shift (MOST POPULAR)
export const HeadingGradientShift = styled.h2`
    background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #667eea 100%);
    background-size: 200% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    transition: background-position 0.5s ease;
    cursor: pointer;
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 20px;

    &:hover {
        background-position: 100% center;
    }

    @media (max-width: 768px) {
        font-size: 2rem;
    }
`

// Animation: Scale + Glow (RECOMMENDED)
export const HeadingScaleGlow = styled.h2`
    transition: all 0.3s ease;
    cursor: pointer;
    color: #2c3e50;
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 20px;

    &:hover {
        transform: scale(1.05);
        color: #667eea;
        text-shadow: 0 0 20px rgba(102, 126, 234, 0.5);
    }

    @media (max-width: 768px) {
        font-size: 2rem;
    }
`

// Animation: Underline Expand
export const HeadingUnderline = styled.h2`
    position: relative;
    display: inline-block;
    cursor: pointer;
    color: #2c3e50;
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 20px;

    &::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 3px;
        background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
        transition: width 0.4s ease;
    }

    &:hover::after {
        width: 100%;
    }

    @media (max-width: 768px) {
        font-size: 2rem;
    }
`

// Animation: Bounce
const bounce = keyframes`
    0%, 100% { transform: translateY(0); }
    25% { transform: translateY(-10px); }
    50% { transform: translateY(0); }
    75% { transform: translateY(-5px); }
`

export const HeadingBounce = styled.h2`
    transition: transform 0.3s ease;
    cursor: pointer;
    color: #2c3e50;
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 20px;

    &:hover {
        animation: ${bounce} 0.6s ease;
    }

    @media (max-width: 768px) {
        font-size: 2rem;
    }
`

// Animation: Pulse
const pulse = keyframes`
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.05); }
`

export const HeadingPulse = styled.h2`
    cursor: pointer;
    color: #2c3e50;
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 20px;

    &:hover {
        animation: ${pulse} 1s ease infinite;
    }

    @media (max-width: 768px) {
        font-size: 2rem;
    }
`

// Animation: Shimmer
export const HeadingShimmer = styled.h2`
    position: relative;
    color: #2c3e50;
    overflow: hidden;
    cursor: pointer;
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 20px;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, 
            transparent, 
            rgba(255, 255, 255, 0.8), 
            transparent
        );
        transition: left 0.5s ease;
    }

    &:hover::before {
        left: 100%;
    }

    @media (max-width: 768px) {
        font-size: 2rem;
    }
`

// Animation: 3D Flip
export const Heading3DFlip = styled.h2`
    transition: transform 0.6s;
    transform-style: preserve-3d;
    cursor: pointer;
    color: #2c3e50;
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 20px;

    &:hover {
        transform: rotateY(360deg);
    }

    @media (max-width: 768px) {
        font-size: 2rem;
    }
`

// Animation: Shadow Grow
export const HeadingShadowGrow = styled.h2`
    transition: all 0.3s ease;
    cursor: pointer;
    color: #2c3e50;
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 20px;

    &:hover {
        text-shadow: 2px 2px 0 #667eea,
                     4px 4px 0 #764ba2,
                     6px 6px 0 rgba(118, 75, 162, 0.5);
    }

    @media (max-width: 768px) {
        font-size: 2rem;
    }
`

// Animation: Rainbow Gradient
export const HeadingRainbow = styled.h2`
    background: linear-gradient(90deg, 
        #667eea 0%, 
        #764ba2 25%, 
        #f093fb 50%, 
        #4facfe 75%, 
        #667eea 100%
    );
    background-size: 400% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    transition: background-position 0.5s ease;
    cursor: pointer;
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 20px;

    &:hover {
        background-position: 100% center;
    }

    @media (max-width: 768px) {
        font-size: 2rem;
    }
`

// Animation: Glitch
const glitch = keyframes`
    0%, 100% { transform: translate(0); }
    20% { transform: translate(-2px, 2px); }
    40% { transform: translate(2px, -2px); }
    60% { transform: translate(-2px, -2px); }
    80% { transform: translate(2px, 2px); }
`

export const HeadingGlitch = styled.h2`
    position: relative;
    color: #2c3e50;
    cursor: pointer;
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 20px;

    &:hover {
        animation: ${glitch} 0.3s ease;
    }

    @media (max-width: 768px) {
        font-size: 2rem;
    }
`

// COMBO: Gradient + Underline (BEST)
export const HeadingGradientUnderline = styled.h2`
    background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #667eea 100%);
    background-size: 200% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    position: relative;
    display: inline-block;
    cursor: pointer;
    transition: background-position 0.5s ease;
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 20px;

    &::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 3px;
        background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
        transition: width 0.4s ease;
    }

    &:hover {
        background-position: 100% center;
    }

    &:hover::after {
        width: 100%;
    }

    @media (max-width: 768px) {
        font-size: 2rem;
    }
`

// COMBO: Scale + Color + Shadow (PROFESSIONAL)
export const HeadingComboFull = styled.h2`
    transition: all 0.4s ease;
    cursor: pointer;
    color: #2c3e50;
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 20px;

    &:hover {
        transform: scale(1.08) translateY(-3px);
        color: #667eea;
        text-shadow: 2px 2px 8px rgba(102, 126, 234, 0.3);
    }

    @media (max-width: 768px) {
        font-size: 2rem;
    }
`

// Animation: Slide Background
export const HeadingSlideBackground = styled.h2`
    position: relative;
    color: #2c3e50;
    cursor: pointer;
    overflow: hidden;
    padding: 10px 20px;
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 20px;
    display: inline-block;

    &::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 0;
        background: linear-gradient(180deg, #667eea, #764ba2);
        transition: height 0.3s ease;
        z-index: -1;
    }

    &:hover::before {
        height: 100%;
    }

    &:hover {
        color: white;
    }

    @media (max-width: 768px) {
        font-size: 2rem;
    }
`

// ============================================
// USAGE COMPONENT EXAMPLES
// ============================================

export const HoverExamples = () => {
    return (
        <div style={{ padding: '40px', maxWidth: '1200px', margin: '0 auto' }}>
            <HeadingGradientShift>Gradient Shift Effect</HeadingGradientShift>
            <p style={{ marginBottom: '40px' }}>Hover over the heading to see the gradient move</p>

            <HeadingScaleGlow>Scale + Glow Effect</HeadingScaleGlow>
            <p style={{ marginBottom: '40px' }}>Hover to see it grow and glow</p>

            <HeadingUnderline>Underline Expand</HeadingUnderline>
            <p style={{ marginBottom: '40px' }}>Hover to see animated underline</p>

            <HeadingBounce>Bounce Effect</HeadingBounce>
            <p style={{ marginBottom: '40px' }}>Hover to see it bounce</p>

            <HeadingPulse>Pulse Effect</HeadingPulse>
            <p style={{ marginBottom: '40px' }}>Hover to see continuous pulse</p>

            <HeadingShimmer>Shimmer Effect</HeadingShimmer>
            <p style={{ marginBottom: '40px' }}>Hover to see light shimmer</p>

            <Heading3DFlip>3D Flip Effect</Heading3DFlip>
            <p style={{ marginBottom: '40px' }}>Hover to see 3D rotation</p>

            <HeadingShadowGrow>Shadow Grow</HeadingShadowGrow>
            <p style={{ marginBottom: '40px' }}>Hover to see layered shadow</p>

            <HeadingRainbow>Rainbow Gradient</HeadingRainbow>
            <p style={{ marginBottom: '40px' }}>Hover to see rainbow colors</p>

            <HeadingGlitch>Glitch Effect</HeadingGlitch>
            <p style={{ marginBottom: '40px' }}>Hover to see glitch animation</p>

            <HeadingGradientUnderline>Gradient + Underline</HeadingGradientUnderline>
            <p style={{ marginBottom: '40px' }}>Best combination effect</p>

            <HeadingComboFull>Scale + Color + Shadow</HeadingComboFull>
            <p style={{ marginBottom: '40px' }}>Professional combo effect</p>

            <HeadingSlideBackground>Slide Background</HeadingSlideBackground>
            <p style={{ marginBottom: '40px' }}>Hover to see background slide up</p>
        </div>
    )
}

// Export all components
export default {
    HeadingGradientShift,
    HeadingScaleGlow,
    HeadingUnderline,
    HeadingBounce,
    HeadingPulse,
    HeadingShimmer,
    Heading3DFlip,
    HeadingShadowGrow,
    HeadingRainbow,
    HeadingGlitch,
    HeadingGradientUnderline,
    HeadingComboFull,
    HeadingSlideBackground,
    HoverExamples
}